import { Colors, typographyStyle, PrimaryColors } from '@revenuemarket/cds';
import { Typography } from 'antd';
import { css } from '~libs/emotion';

const AddNode = ({ title }: { title?: string }) => {
  return (
    <Typography.Text
      className={css`
        display: flex;
        align-items: center;
        color: ${Colors.gray300};
        padding-left: 6px;
        ${typographyStyle['13_400']}
        &:hover {
          color: ${PrimaryColors.primary500};
        }
      `}
    >
      {`+ 하위 ${title ?? '계정'}`}
    </Typography.Text>
  );
};

export default AddNode;
